import { createResourceBuilder } from '../resource';
import { EResourceMethod } from '../models/IPermission';
import { invitationIdParam, oldRoleIdParam, orgNameParam, userIdParam } from './builderHelper';

export const organizationResources = {
  listOrganizationUsers: createResourceBuilder(
    '/identities/organization/:organization_name/users',
    EResourceMethod.Get,
    (organization_name: string) => ({ organization_name })
  ),
  inviteUsers: createResourceBuilder(
    '/identities/organization/invite/:organization_name',
    EResourceMethod.Post,
    (organization_name: string) => ({ organization_name })
  ),
  acceptInvitation: createResourceBuilder(
    '/identities/organization/:organization_name/invitation/accept/:token',
    EResourceMethod.Post,
    (organization_name: string, token: string) => ({ organization_name, token })
  ),
  getInvitationDetails: createResourceBuilder(
    '/identities/organization/public/invitation/:token',
    EResourceMethod.Get,
    (token: string) => ({ token })
  ),
  acceptInvitationAndSignUp: createResourceBuilder(
    '/identities/organization/:organization_name/invitation/:token/signup',
    EResourceMethod.Post,
    (organization_name: string, token: string) => ({ organization_name, token })
  ),
  rejectInvitationAuthenticated: createResourceBuilder(
    '/identities/organization/:organization_name/invitation/:token',
    EResourceMethod.Delete,
    (organization_name: string, token: string) => ({ organization_name, token })
  ),
  cancelInvitation: createResourceBuilder(
    '/identities/organization/:organization_name/invitation/id/:invitation_id',
    EResourceMethod.Delete,
    orgNameParam(invitationIdParam())
  ),
  getOrganizations: createResourceBuilder('/identities/organization', EResourceMethod.Get),
  getOrganizationsByIds: createResourceBuilder('/identities/organization/by-ids', EResourceMethod.Get),
  createOrganization: createResourceBuilder('/identities/organization', EResourceMethod.Post),
  getOrganizationByName: createResourceBuilder(
    '/identities/organization/:organization_name',
    EResourceMethod.Get,
    (organization_name: string) => ({ organization_name })
  ),
  archiveOrganizationByName: createResourceBuilder(
    '/identities/organization/:organization_name/archive',
    EResourceMethod.Patch,
    (organization_name: string) => ({ organization_name })
  ),
  unArchiveOrganizationByName: createResourceBuilder(
    '/identities/organization/:organization_name/archived/unarchive',
    EResourceMethod.Patch,
    (organization_name: string) => ({ organization_name })
  ),
  updateOrganizationByName: createResourceBuilder(
    '/identities/organization/:organization_name',
    EResourceMethod.Patch,
    (organization_name: string) => ({ organization_name })
  ),
  updateCurrentOrganizationByName: createResourceBuilder(
    '/identities/organization/:organization_name/by-owner',
    EResourceMethod.Patch,
    (organization_name: string) => ({ organization_name })
  ),
  assignUserToOrganization: createResourceBuilder(
    '/identities/organization/:organization_name/user/:user_id',
    EResourceMethod.Put,
    (organization_name: string, user_id: string) => ({ organization_name, user_id })
  ),
  getInvitations: createResourceBuilder(
    '/identities/organization/:organization_name/invitations',
    EResourceMethod.Get,
    (organization_name: string) => ({ organization_name })
  ),
  removeUser: createResourceBuilder(
    '/identities/organization/:organization_name/user/:user_id',
    EResourceMethod.Delete,
    (organization_name: string, user_id: string) => ({ organization_name, user_id })
  ),
  getUser: createResourceBuilder(
    '/identities/organization/:organization_name/members/:user_id',
    EResourceMethod.Get,
    (organization_name: string, user_id: string) => ({ organization_name, user_id })
  ),
  updateMemberRole: createResourceBuilder(
    '/identities/organization/:organization_name/user/:user_id/role/:old_role_id',
    EResourceMethod.Patch,
    orgNameParam(userIdParam(oldRoleIdParam()))
  ),
  changeOwner: createResourceBuilder(
    '/identities/organization/:organization_name/owner/:user_id',
    EResourceMethod.Put,
    orgNameParam(userIdParam())
  ),
  deleteArchivedOrganization: createResourceBuilder(
    '/identities/organization/:organization_name/archived',
    EResourceMethod.Delete,
    orgNameParam()
  ),
} as const;
